.root {
  --dropzone-accept-bg: var(--mantine-color-primary-light);
  --dropzone-accept-color: var(--mantine-color-primary-filled);
  --dropzone-reject-bg: var(--mantine-color-danger-light);
  --dropzone-reject-color: var(--mantine-color-danger-filled);

  background-color: var(--mantine-color-gray-light);
  border-color: var(--mantine-color-gray-light-hover);

  &[data-disabled] {
    background-color: light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-5));
    cursor: not-allowed;
  }

  &[data-accept] {
    background-color: var(--dropzone-accept-bg);
    border-color: var(--dropzone-accept-color);
    border-style: solid;
  }

  &[data-reject] {
    background-color: var(--dropzone-reject-bg);
    border-color: var(--dropzone-reject-color);
    border-style: solid;
  }
}
